// extracted by mini-css-extract-plugin
export default {"cont":"Msg_cont__bCP2h"};